import { render, staticRenderFns } from "./outofoffices.component.vue?vue&type=template&id=5737bcee&"
import script from "./outofoffices.component.vue?vue&type=script&lang=js&"
export * from "./outofoffices.component.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports